import * as React from 'react';
import './styles.scss';

interface UnderlineTitleProps {
  title: string;
  containerTheme: string;
  className?: string;
  disableUppercase?: boolean;
}

const UnderlineTitle = ({
  title,
  containerTheme,
  className,
  disableUppercase,
}: UnderlineTitleProps) => (
  <h2 className={`
    underline-title underline-title--${containerTheme}
    ${className} ${disableUppercase ? 'underline-title--disable-uppercase' : ''}
  `}
  >
    {title}
  </h2>
);

export default UnderlineTitle;
